import Vue from 'vue'

export default {
    enviar: (notification) => {
        console.log(notification);
        return Vue.prototype.$http("/graphql", {
            data:{
              query: `{
                enviarPush(title: "${notification.title}", body: "${notification.body}")
              }`
            }
        })
    },
}
